export const NodeListRepository = Symbol.for('NodeListRepository');
